<div [appEnforcePermission]="authConfig.investigationScheduledDateUpdateOwn"
  #investigationScheduledDateUpdateOwn="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.investigationScheduledDateUpdateAll"
  #investigationScheduledDateUpdateAll="appEnforcePermission"></div>

<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title" *ngIf="staffList?.length === 0">
      <span>{{ investigator | fullName }}</span>
    </div>
    <kendo-gridlayout class="title-wrapper" *ngIf="staffList?.length" [rows]="['auto']" [gap]="{rows: 5, cols: 16}"
      [cols]="['repeat(1,minmax(0,1fr))']">
      <kendo-gridlayout-item class="mb-0 staff-member">
        <div class="kendo-formfield">
          <kendo-label text="Staff Member"></kendo-label>
          <kendo-dropdownlist class="ml-12" [data]="staffList" textField="userName" valueField="id"
            (selectionChange)="changeInvestigator($event)" fillMode="outline" [value]="investigator" [popupSettings]="{
            appendTo: 'component',
            animate: false,
            width: 250
          }">
            <ng-template kendoDropDownListValueTemplate let-dataItem>
              <span>{{ dataItem | fullName }}</span>
            </ng-template>
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span>{{ dataItem | fullName }}</span>
            </ng-template>
          </kendo-dropdownlist>
        </div>
        <ng-container
          *ngIf="investigation?.id && (investigationScheduledDateUpdateOwn?.enabled || investigationScheduledDateUpdateAll?.enabled)">
          <button kendoButton themeColor="primary" fillMode="solid" iconClass="fa-solid fa-plus" class="mr-16"
            (click)="nextSchedule()">Create New On
            Scene Exam Investigation</button>
        </ng-container>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </kendo-dialog-titlebar>
  <section class="p-0">
    <kendo-tabstrip class="profile-sidebar-tabs" [tabAlignment]="'justify'">
      <kendo-tabstrip-tab [selected]="true">
        <ng-template kendoTabTitle>
          <div class="tab-title-div">
            <i class="fa-solid fa-calendar"></i>
            <span>Calendar</span>
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <kendo-card width="100%" class="mt-8">
            <div class="p-10">
              <app-calendar [userIds]="userIds" [showFilters]="false" [showTitle]="false"
                [distanceSelection]="distanceSelection" [showTabs]="false"></app-calendar>
            </div>
          </kendo-card>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab>
        <ng-template kendoTabTitle>
          <div class="tab-title-div">
            <i class="fa-solid fa-user"></i>
            <span>Profile</span>
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <kendo-card width="100%" class="mt-8" *ngIf="investigator?.id">
            <app-staff-profile [userId]="investigator.id"></app-staff-profile>
          </kendo-card>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </section>
</div>
